import React from "react";
import { Link } from "react-router-dom";

function ResetPasswordForm({
  onSubmit,
  register,
  errors,
  email,
  otp,
  otpExpired,
  resendTimer,
  handleResendOtp,
  formatTime,
}) {
  return (
    <div>
      <div className="card-body">
        <p className="login-box-msg">
          You are only one step a way from your new password, recover your
          password now.
        </p>
        <form onSubmit={onSubmit}>
          <div className="input-group mb-3">
            <input
              type="email"
              className={`form-control ${errors.email?.message ? 'is-invalid': ''}`}
              placeholder="Email"
              value={email}
              readOnly
              {...register("email", {
                required: "Email is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Invalid email address",
                },
              })}
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <span className="fas fa-envelope" />
              </div>
            </div>
            {errors.email && (
              <span className="invalid-feedback">{errors.email.message}</span>
            )}
          </div>

          <div className="input-group">
            <input
              type="text"
              className={`form-control ${errors.otp?.message ? 'is-invalid': ''}`}
              placeholder="OTP"
              {...register("otp", { required: "OTP is required" })}
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <span className="fas fa-key" />
              </div>
            </div>
            {errors.otp && (
              <span className="invalid-feedback">{errors.otp.message}</span>
            )}
            
          </div>
          <div className="expire-otp mb-3">
              {resendTimer > 0 ? (
                <p>OTP expire in: {formatTime(resendTimer)}</p>
              ) : (
                <button
                  className="btn btn-primary expire-btn"
                  type="button"
                  onClick={handleResendOtp}
                  disabled={!otpExpired}
                >
                  Resend OTP
                </button>
              )}
          </div>
          <div className="input-group mb-3">
            <input
              type="password"
              className={`form-control ${errors.password?.message ? 'is-invalid': ''}`}
              placeholder="Password"
              {...register("password", { required: "Password is required" })}
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <span className="fas fa-lock" />
              </div>
            </div>
            {errors.password && (
              <span className="invalid-feedback">{errors.password.message}</span>
            )}
          </div>

          <div className="input-group mb-3">
            <input
              type="password"
              className={`form-control ${errors.confirmPassword?.message ? 'is-invalid': ''}`}
              placeholder="Confirm Password"
              {...register("confirmPassword", {
                required: "Confirm Password is required",
              })}
            />
            <div className="input-group-append">
              <div className="input-group-text">
                <span className="fas fa-lock" />
              </div>
            </div>
            {errors.confirmPassword && (
              <span className="invalid-feedback">
                {errors.confirmPassword.message}
              </span>
            )}
          </div>

          <div className="row">
            <div className="col-12">
              <button type="submit" className="btn btn-primary btn-block">
                Reset password
              </button>
            </div>
          </div>
        </form>
        <p className="mt-3 mb-1">
          <Link to="/login">Already have an account? Sign In</Link>
        </p>
      </div>
    </div>
  );
}
export default ResetPasswordForm;
